module.exports = __webpack_public_path__ + "static/media/banner-BF-icon_03.fc869360.png";